import { combineReducers } from "redux";

import slice from "./portfolioSlice";

import filters from "./filters";
import overview from "./overview";
import revenue from "./revenue";
import profit from "./profit";
import drivers from "./drivers";
import catchment from "./catchment";
import competition from "./competition";
import competitionNew from "./competitionNew";
import areaHealth from "./areaHealth";
import areaHealthNew from "./areaHealthNew";
import footfall from "./footfall";
import footfallNew from "./footfallNew";

const reducer = combineReducers({
    root: slice.reducer,
    filters,
    overview,
    revenue,
    profit,
    drivers,
    catchment,
    competition,
    competitionNew,
    areaHealth,
    areaHealthNew,
    footfall,
    footfallNew
});

export default reducer;
